//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
SPLM.AME.AmeTeeJunctionType = Object.freeze({
    "HorizontalDown" : "HorizontalDown", "HorizontalUp" : "HorizontalUp", "VerticalLeft" : "VerticalLeft", "VerticalRight" : "VerticalRight", "Invalid" : "Invalid"});

SPLM.AME.AmeTeeJunctionVariant = Object.freeze({
    "One" : "One", "Two" : "Two", "Three" : "Three"});

SPLM.AME.AmeJunctionRepresentationStyleType = Object.freeze({
    "Point" : "Point", "TargetSpecific" : "TargetSpecific", "Invalid" : "Invalid"});

export default SPLM;